import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Send } from '@mui/icons-material';
import React, { useState } from 'react';

type LessonTextInputProps = {
  micButtonMuted: boolean;
  handleSend: (value: string) => void;
};
export const OpenEndedTextInput = ({ micButtonMuted, handleSend }: LessonTextInputProps) => {
  const [responseValue, setResponseValue] = useState<string>('');

  const handleSubmit = () => {
    handleSend(responseValue);
    setResponseValue('');
  };
  const handleKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  const handleEntry = (e: React.ChangeEvent<HTMLInputElement>) => {
    setResponseValue(e.target.value);
  };

  return (
    <TextField
      data-testid='response-input'
      name='response'
      label=''
      type='text'
      disabled={!micButtonMuted}
      onKeyDown={handleKey}
      onChange={handleEntry}
      value={responseValue}
      sx={{
        display: 'flex',
        padding: '0.2em 0em 0.2em 1.1em',
        maxWidth: '560px',
        alignItems: 'center',
        flexShrink: '0',
        alignSelf: 'stretch',
        borderRadius: '0.2em 0.2em 0em 0em',
      }}
      InputProps={{
        readOnly: Boolean(false),
        'aria-label': 'student response',
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              sx={{
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                  color: 'primary.contrastText',
                },
              }}
              data-testid='response-input-button'
              aria-label='submit response button'
              type='submit'
              edge='end'
              onClick={handleSubmit}
            >
              <Send />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
